/* eslint-disable complexity */
import { BookWidgetFlexDatesField } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

export const prepareFlexDatesField = (
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  hasDeepLinkingParams: boolean
): BookWidgetFlexDatesField => {
  if (bookWidgetFieldsMasterConfig.flexDatesField?.hide) {
    return {
      checked: false,
      disable: false,
      hide: true
    };
  }

  let checked = false;
  if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.flexDatesField?.disable &&
    retrieveSearchData?.chkFlexDate
  ) {
    checked = true;
  }

  return {
    checked,
    disable: bookWidgetFieldsMasterConfig.flexDatesField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.flexDatesField?.hide || false
  };
};
